import React from "react";
import {
  QueryPerformanceMetricsData,
  SubscribePerformanceMetricsData,
  SubscribeAppendPerformanceMetricsData,
} from "../../../utils/graphql/hooks/performanceMetricsHooks";

export default function PerformanceMetricsDataManager() {
  QueryPerformanceMetricsData();
  SubscribePerformanceMetricsData();
  SubscribeAppendPerformanceMetricsData();
  return <></>;
}
